var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("router-view"),
      _vm._v(" "),
      _vm.editRoleDialogVisible
        ? _c("edit-role-dialog", {
            attrs: {
              role: _vm.editRole,
              "permissions-tree": _vm.permissionsTree
            },
            on: {
              roleUpdated: _vm.getList,
              closeDialog: _vm.handleCloseEditRoleDialog
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.createRoleDialogVisible
        ? _c("create-role-dialog", {
            attrs: { "permissions-tree": _vm.permissionsTree },
            on: {
              roleCreated: _vm.getList,
              closeDialog: _vm.handleCloseCreateRoleDialog
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showPage
        ? _c(
            "main",
            { staticClass: "role-overview" },
            [
              _c(
                "el-row",
                { staticClass: "filter-container clearfix" },
                [
                  _c(
                    "el-col",
                    [
                      _c("label", [_vm._v("角色名称")]),
                      _vm._v(" "),
                      _c("el-input", {
                        staticClass: "width-160",
                        attrs: { placeholder: "角色名称", size: "medium" },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleFilter($event)
                          }
                        },
                        model: {
                          value: _vm.listQuery.keyword,
                          callback: function($$v) {
                            _vm.$set(_vm.listQuery, "keyword", $$v)
                          },
                          expression: "listQuery.keyword"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.resetForm } }, [
                        _vm._v("重置")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: { type: "primary" },
                          on: { click: _vm.handleFilter }
                        },
                        [_vm._v("查询")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: { type: "primary" },
                          on: { click: _vm.handleCreateRole }
                        },
                        [_vm._v("新建")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading"
                    }
                  ],
                  staticClass: "table-wrap",
                  attrs: {
                    data: _vm.list,
                    "default-sort": { prop: "createdAt", order: "descending" },
                    border: "",
                    stripe: "",
                    fit: "",
                    "highlight-current-row": ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "名称", "min-width": "100", align: "left" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              row.label
                                ? _c("span", [_vm._v(_vm._s(row.label))])
                                : _c("span", [_vm._v("--")])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3552128375
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "创建时间",
                      prop: "createdAt",
                      sortable: "",
                      "min-width": "110",
                      align: "left"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatUTCDate")(
                                      row.createdAt,
                                      "YYYY-MM-DD"
                                    )
                                  )
                                )
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4119576081
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "权限", "min-width": "240", align: "left" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return _vm._l(
                              _vm.filterRolePermissions(row.permissions),
                              function(permission) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: permission._id,
                                    staticClass: "mr-8 mb-8",
                                    attrs: { type: "success" }
                                  },
                                  [_vm._v(_vm._s(permission.label))]
                                )
                              }
                            )
                          }
                        }
                      ],
                      null,
                      false,
                      3288404740
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "left", label: "操作", "min-width": "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var row = ref.row
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleEdit(row)
                                    }
                                  }
                                },
                                [_vm._v("编辑")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1621167423
                    )
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.total > 0,
                    expression: "total > 0"
                  }
                ],
                attrs: { total: _vm.total, page: _vm.page, limit: _vm.limit },
                on: {
                  "update:page": function($event) {
                    _vm.page = $event
                  },
                  "update:limit": [
                    function($event) {
                      _vm.limit = $event
                    },
                    _vm.updateLimit
                  ],
                  pagination: _vm.getList
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }